/* START_MODULE_CONTRACT
 * PURPOSE: Pure helpers for feature list grouping (Очередь / Бэклог / Архив).
 * SCOPE: partition by status; merge reorder within a group into full ordered list.
 * DEPENDS: нет
 * LINKS: M-FE-FEATURES, UC-020, V-M-FE-FEATURES
 * ROLE: UTILITY
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * partitionFeatureGroups - split features into queue / backlog / archive by status
 * mergeGroupReorder - rebuild full ordered list after DnD within one group
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-28 - UC-020: группы статуса и merge reorder.
 * END_CHANGE_SUMMARY
 */

/* START_METHOD_partitionFeatureGroups */
/* START_CONTRACT: partitionFeatureGroups
 * PURPOSE: Разбить список фич на Очередь (IN_PROGRESS), Бэклог (BACKLOG), Архив (ARCHIVED).
 * INPUTS: { features: Feature[] }.
 * OUTPUTS: { queue: Feature[], backlog: Feature[], archive: Feature[] }.
 * SIDE_EFFECTS: нет.
 * LINKS: UC-020
 * END_CONTRACT: partitionFeatureGroups
 */
export function partitionFeatureGroups(features = []) {
  const queue = [];
  const backlog = [];
  const archive = [];

  for (const feature of features) {
    if (feature.status === 'ARCHIVED' || feature.isArchived) {
      archive.push(feature);
    } else if (feature.status === 'BACKLOG' || feature.isBacklog) {
      backlog.push(feature);
    } else {
      queue.push(feature);
    }
  }

  return { queue, backlog, archive };
}
/* END_METHOD_partitionFeatureGroups */

/* START_METHOD_mergeGroupReorder */
/* START_CONTRACT: mergeGroupReorder
 * PURPOSE: После DnD внутри группы собрать полный порядок: queue → backlog → archive.
 * INPUTS: { groups: {queue,backlog,archive}, groupKey: 'queue'|'backlog'|'archive', reorderedGroup: Feature[] }.
 * OUTPUTS: { Feature[] - полный список для reorder API }.
 * SIDE_EFFECTS: нет.
 * LINKS: UC-020
 * END_CONTRACT: mergeGroupReorder
 */
export function mergeGroupReorder(groups, groupKey, reorderedGroup) {
  const next = {
    queue: groups.queue,
    backlog: groups.backlog,
    archive: groups.archive,
    [groupKey]: reorderedGroup,
  };
  return [...next.queue, ...next.backlog, ...next.archive];
}
/* END_METHOD_mergeGroupReorder */
